import { ApiError, api, getTokenSubject } from './api/client';
import { deleteQueuedResponse, listQueuedResponses, markQueueFailure } from './offline';

let syncing = false;

/** Upload pending PWA responses when the app is open and the network is available. */
export async function syncQueuedResponses(): Promise<void> {
  if (!navigator.onLine || syncing) return;
  syncing = true;
  try {
    const items = await listQueuedResponses().catch(() => []);
    const accountSubject = getTokenSubject();
    for (const item of items.filter((entry) => entry.status === 'pending' && entry.accountSubject === accountSubject)) {
      try {
        await api.submit(item.surveyCode, item.submission);
        await deleteQueuedResponse(item.id);
      } catch (error) {
        // A failed or unavailable captcha can succeed on a later attempt.
        if (error instanceof ApiError && !error.code.startsWith('captcha_') && [400, 403, 404, 410, 422].includes(error.status)) {
          await markQueueFailure(item.id, error.message);
        }
        // Network/server errors and 401 remain pending for a later retry.
      }
    }
  } finally {
    syncing = false;
    window.dispatchEvent(new Event('yellowmetrics-outbox-change'));
  }
}
